export type ImageSettingsTypes = {
  imageType: ImageTypeEnum;
  indentRight: number;
  indentLeft: number;
  indentTop: number;
  indentRedLine: number;
  isDoublePage: boolean;
};

export enum ImageTypeEnum {
  CAGE = 'cage',
  LINE = 'line',
  EMPTY = 'empty',
  CUSTOM = 'custom',
}
